export var clientRequestIdHeader = 'client-request-id';
export var serverRequestIdHeader = 'request-id';
export var recommendedPersistenceKey = 'recommended-api';
export var recommendedPersistenceVersion = 3;
export var officeFeedPersistenceKey = 'officefeed-v2-api';
//# sourceMappingURL=constants.js.map